import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel as ReactCarousel } from 'react-responsive-carousel';
import { CarouselImage } from 'types/home-page';
import Box from '@mui/material/Box';
import { Theme } from '@mui/material';

interface Props {
    images: CarouselImage[];
}

const imageStyles = ({ breakpoints }: Theme) => ({
    maxHeight: '300px',
    objectFit: 'contain',
    [breakpoints.up('md')]: {
        maxHeight: '500px',
    },
});

export const Carousel = ({ images }: Props) => {
    return (
        <ReactCarousel autoPlay infiniteLoop showStatus={false} showThumbs={false}>
            {images.map(({ id, fileName, filePath }) => (
                <div key={id}>
                    <Box component="img" src={filePath} sx={imageStyles} />
                </div>
            ))}
        </ReactCarousel>
    );
};
